export enum MerchantPaymentsStatsPeriod {
  'DAILY' = 'DAILY',
  'WEAKLY' = 'WEAKLY',
  'MONTHLY' = 'MONTHLY'
}
